import { useState } from 'react';
import { translateText } from '../api/translate.service';

const GOOGLE_LANG_MAP = {
  ua: 'uk',
  en: 'en',
};

function getByPath(obj, path) {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
}

export function useAutoTranslate(formik) {
  const [isTranslating, setIsTranslating] = useState(false);

  // Перекладач — публічний ендпоінт Google, тож десятки одночасних запитів
  // він просто відсіче. Йдемо невеликими пачками: для двох-трьох полів
  // різниці не видно, а для форми програми (кілька десятків) це рятує.
  const translateFields = async (pairs, { concurrency = 4 } = {}) => {
    setIsTranslating(true);

    let translated = 0;
    let failed = 0;

    try {
      for (let index = 0; index < pairs.length; index += concurrency) {
        const chunk = pairs.slice(index, index + concurrency);

        // eslint-disable-next-line no-await-in-loop
        const results = await Promise.allSettled(
          chunk.map(async ({ from, to }) => {
            const sourceText = getByPath(formik.values, from);
            if (!sourceText?.trim()) return false;

            const sourceLang = from.split('.').at(-1);
            const targetLang = to.split('.').at(-1);

            const result = await translateText(
              sourceText,
              GOOGLE_LANG_MAP[sourceLang] ?? sourceLang,
              GOOGLE_LANG_MAP[targetLang] ?? targetLang,
            );

            if (result) {
              formik.setFieldValue(to, result);
              return true;
            }

            return false;
          }),
        );

        results.forEach((result) => {
          if (result.status === 'rejected') {
            failed += 1;
          } else if (result.value) {
            translated += 1;
          }
        });

        const rejected = results.filter((result) => result.status === 'rejected');
        if (rejected.length > 0) {
          console.error(
            '[useAutoTranslate] Some translations failed:',
            rejected.map((result) => result.reason),
          );
        }
      }
    } finally {
      setIsTranslating(false);
    }

    return { translated, failed, total: pairs.length };
  };

  return { translateFields, isTranslating };
}
